import { render } from "./CreateIDRFlowset.vue?vue&type=template&id=04c8235d&scoped=true"
import script from "./CreateIDRFlowset.vue?vue&type=script&lang=js"
export * from "./CreateIDRFlowset.vue?vue&type=script&lang=js"

import "./CreateIDRFlowset.vue?vue&type=style&index=0&id=04c8235d&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c8235d"]])

export default __exports__